import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import { BsFillSuitHeartFill } from "react-icons/bs";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Manubar from "./Manubar";
import { useCart } from "./CartContext";
import "./loader.css";

const API_BASE_URL = `${process.env.REACT_APP_API}website`;
const Shops_category = () => {
  const navigate = useNavigate();
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const subCategoryListId = secureLocalStorage.getItem(
    "n_sub_category_list_id",
  );

  const fetchCategories = async () => {
    try {
      const subCatData = {
        category_id: subCategoryListId,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}website/sub_category_list`,
        subCatData,
      );

      if (data?.result) {
        setCategoryList(data.data);
      } else {
        setError("No categories found");
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCategoryClick = (id) => {
    if (!id) return;
    navigate("/shop", { state: { subCategory_id: id } });
  };

  if (loading)
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );

  return (
    <div style={{ minHeight: "100vh" }}>
      <ToastContainer position="top-center" />

      {/* Modals */}
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar />
        <Navbar />
      </header>

      {/* Breadcrumb */}
      <nav
        className="breadcrumb-section"
        style={{ backgroundColor: "#160015", padding: "1rem 0" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "#fff" }}
                >
                  {categoryList[0]?.category_name}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      <section className="categories">
        <div className="container-fluid">
          <h2
            style={{
              fontSize: "1.75rem",
              fontWeight: "600",
              color: "#160015",
              marginBottom: "2rem",
              textAlign: "center",
              paddingTop: "2rem",
            }}
          >
            {categoryList[0]?.category_name}
          </h2>

          <div className="grid">
            {categoryList.length > 0 ? (
              categoryList.map((item) => (
                <div
                  className="card"
                  key={item.sub_category_id}
                  onClick={() => handleCategoryClick(item.sub_category_id)}
                  style={{
                    cursor: "pointer",
                    textAlign: "center",
                    transition: "transform 0.2s, border-color 0.2s",
                    padding: "1.5rem",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    border: "2px solid #160015",
                    boxShadow: "0 4px 12px rgba(22, 0, 21, 0.1)",
                  }}
                >
                  <img
                    src={`${process.env.REACT_APP_API}uploads/${item.sub_category_image}`}
                    alt={item.sub_category_name}
                    onError={(e) =>
                      (e.target.src = "/no-image-placeholder.jpg")
                    }
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover",
                      borderRadius: "50%",
                      margin: "0 auto 1rem",
                    }}
                  />
                  <h3
                    style={{
                      fontSize: "1rem",
                      fontWeight: "600",
                      color: "#160015",
                      margin: "0",
                    }}
                  >
                    {item.sub_category_name}
                  </h3>
                </div>
              ))
            ) : (
              <div
                className="no-data"
                style={{
                  gridColumn: "1 / -1",
                  textAlign: "center",
                  padding: "3rem 1rem",
                }}
              >
                <p
                  className="no-data-text"
                  style={{
                    fontSize: "1.25rem",
                    color: "#160015",
                    fontWeight: "500",
                  }}
                >
                  No data found
                </p>
              </div>
            )}
          </div>
        </div>

        <style jsx>{`
          .categories {
            padding: 2rem 1rem;
          }

          .grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 1.5rem;
            max-width: 1200px;
            margin: 0 auto;
          }

          .card:hover {
            transform: translateY(-5px);
            border-color: #fee894;
            box-shadow: 0 8px 20px rgba(22, 0, 21, 0.15);
          }

          /* Loading */
          .loading {
            text-align: center;
            padding: 4rem;
            background-color: #fef9e7;
          }

          .spinner {
            width: 40px;
            height: 40px;
            border: 3px solid #f0f0f0;
            border-top-color: #160015;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin: 0 auto 1rem;
          }

          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }

          .loading p {
            color: #160015;
            font-weight: 500;
          }

          /* Error */
          .error {
            text-align: center;
            padding: 4rem;
            background-color: #fef9e7;
          }

          .error p {
            color: #160015;
            margin-bottom: 1rem;
            font-weight: 500;
          }

          .error button {
            padding: 0.5rem 1.5rem;
            background: #160015;
            color: #fee894;
            border: 2px solid #160015;
            border-radius: 6px;
            cursor: pointer;
            font-size: 0.9rem;
            font-weight: 600;
            transition: all 0.2s;
          }

          .error button:hover {
            background: #fee894;
            color: #160015;
          }

          /* Responsive */
          @media (max-width: 992px) {
            .grid {
              grid-template-columns: repeat(3, 1fr);
            }
          }

          @media (max-width: 768px) {
            .grid {
              grid-template-columns: repeat(2, 1fr);
              gap: 1rem;
            }

            .card {
              padding: 1rem;
            }

            .card img {
              width: 100px !important;
              height: 100px !important;
            }

            h2 {
              font-size: 1.5rem !important;
            }
          }

          @media (max-width: 480px) {
            .grid {
              grid-template-columns: repeat(2, 1fr);
              gap: 0.75rem;
            }

            .card {
              padding: 0.75rem;
            }

            .card img {
              width: 80px !important;
              height: 80px !important;
              
            }

            .card h3 {
              font-size: 0.9rem !important;
            }
          }

          @media (max-width: 360px) {
            .grid {
              grid-template-columns: 1fr;
            }
          }
        `}</style>
      </section>

      
    </div>
  );
};

export default Shops_category;
